<template>
	<div class="preview-pictures flex flex-align-center flex-just-center" @click="$emit('close')">
		<img @click.stop="isShow = false" :src="src" alt="" />
	</div>
</template>
<script>
export default {
	props: {
		src: {
			type: String,
			default: '',
			isShow: false,
		},
	},
};
</script>
<style lang="less" scoped>
.preview-pictures {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	z-index: 9999;
	background-color: rgba(0, 0, 0, 0.3);
	img {
		max-height: 680px;
		max-width: 1000px;
	}
}
</style>
